import { IconBase } from "@Components/Icons/IconBase";

export class Error extends IconBase {
  protected cssClassName: string = "Error";

  protected get icon(): JSX.Element {
    return (
      <svg viewBox="0 0 32.35 32.35">
        <path d="M16.18,0A16.18,16.18,0,1,0,32.35,16.18,16.19,16.19,0,0,0,16.18,0Zm0,30.75A14.57,14.57,0,1,1,30.75,16.18,14.59,14.59,0,0,1,16.18,30.75Z" />
        <polygon points="11 18.77 11 18.77 8.41 21.35 11 23.94 11 23.94 11 23.94 23.94 11 21.35 8.41 11 18.77" />
        <polygon points="21.35 18.77 21.35 18.77 23.94 21.35 21.35 23.94 21.35 23.94 21.35 23.94 8.41 11 11 8.41 21.35 18.77" />
      </svg>
    );
  }
}
